import React from 'react';

import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { useExit } from 'src/hooks/useExit';

export function ProviderNoNewPatients() {
    const exit = useExit();

    return (
        <>
            <ContentContainer className="flex-1 space-y-6 text-center lg:flex-none">
                <FeaturedIcon size="lg" color="error" className="mx-auto mb-8" />
                <h1 className="text-2xl font-medium text-gray-900">This provider is not accepting new patients.</h1>
                <p>Please contact the clinic directly or go back to select another provider.</p>
            </ContentContainer>
            <StickyBottomBar>
                <Button className="w-full" color="gray" onClick={() => exit()}>
                    Exit
                </Button>
            </StickyBottomBar>
        </>
    );
}
